import { QuoteNoSupplierAssignedResponse } from "@/main/models/response";
import { Cart, CartActionTypes, CartPart, CartTypes } from "./cartTypes";

export function addCart(items: Cart, guidQuoteSupplierItem: string | null = null) {
	return {
		type: CartTypes.ADDING_CART,
		payload: { data: items, guidQuoteSupplierItem },
	};
}
export function addCartReducer(items: Cart) {
	return {
		type: CartTypes.ADD_CART,
		payload: { data: items },
	};
}

export function updateCart(item: CartPart, guidSupplier: string, guidQuoteSupplierItem: string | null = null) {
	return {
		type: CartTypes.UPDATING_CART,
		payload: { data: item, guidSupplier, guidQuoteSupplierItem },
	};
}
export function updateCartReducer(item: CartPart, guidSupplier: string) {
	return {
		type: CartTypes.UPDATE_CART,
		payload: { data: item, guidSupplier },
	};
}

export function saveCart(
	data: Cart[],
	dataNoSupplierAssigned: QuoteNoSupplierAssignedResponse | null,
	dataUnansweredItems: QuoteNoSupplierAssignedResponse | null,
	dataUnansweredCanceledItems: QuoteNoSupplierAssignedResponse | null,
	dataUnansweredRequotedItems: QuoteNoSupplierAssignedResponse | null,
	isError: boolean,
	errorMessages: string[] | null,
): CartActionTypes {
	return {
		type: CartTypes.SAVE_CART,
		payload: {
			data,
			dataNoSupplierAssigned,
			dataUnansweredItems,
			isError,
			errorMessages,
			dataUnansweredCanceledItems,
			dataUnansweredRequotedItems,
		},
	};
}

export function removeCart(
	guidQuoteSupplierItem: string,
	idPart: string,
	isError: boolean,
	removeQuoteItem: boolean,
	errorMessages: string[],
): CartActionTypes {
	return {
		type: CartTypes.REMOVING_CART,
		payload: {
			guidQuoteSupplierItem,
			idPart,
			isError,
			removeQuoteItem,
			errorMessages,
		},
	};
}
export function removeCartReducer(
	guidQuoteSupplierItem: string,
	idPart: string,
	isError: boolean,
	errorMessages: string[],
): CartActionTypes {
	return {
		type: CartTypes.REMOVE_CART,
		payload: {
			guidQuoteSupplierItem,
			idPart,
			isError,
			errorMessages,
		},
	};
}

export function loadCart(guidQuote: string): CartActionTypes {
	return {
		type: CartTypes.LOAD_CART,
		payload: {
			guidQuote,
		},
	};
}

export function errorCart(): CartActionTypes {
	return {
		type: CartTypes.ERROR_CART,
	};
}
export function clearAllCart(guidQuote: string): CartActionTypes {
	return {
		type: CartTypes.CLEAR_ALL_CART,
		payload: {
			guidQuote,
		},
	};
}

export function setErrorsGeneralCart(errorMessages: string[]): CartActionTypes {
	return {
		type: CartTypes.SET_ERRORS_GENERAL_CART,
		payload: {
			errorMessages,
		},
	};
}

export function resetReducerCart(): CartActionTypes {
	return {
		type: CartTypes.RESET_REDUCER_CART,
	};
}
